export const getNameInKebabCase = (name: string) => {
  return name
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => "-" + chr)
    .trim();
};
